import { MiddlewareManager } from 'js-middleware';
import { AxiosError } from 'axios';
import { container } from 'tsyringe';
import IRepositoryWrapper from '@/Repository/Base/IRepositoryWrapper';
import RepositoryWrapper from '@/Repository/Base/RepositoryWrapper';
import { environment } from '@/environment/environment';
import { IErrorMessageHanlder, IErrorResult } from '@/Instructure/baseModels/IErrorMessageHandler';
import { LocalStorageService } from '@/Application/core/services/localStorageService';

export default class BaseService {
    private middlewareManager: typeof MiddlewareManager;
    private errorMessageHandle: IErrorMessageHanlder;
    repositoryWrapper: IRepositoryWrapper;
    localStorageService: LocalStorageService


    constructor(
        errorMessageHandle: IErrorMessageHanlder,
    ) {
        this.repositoryWrapper = container.resolve(RepositoryWrapper);
        this.middlewareManager = new MiddlewareManager(this);
        this.errorMessageHandle = errorMessageHandle;
        this.localStorageService = new LocalStorageService();
    }

    protected setMiddlware(middleware: any, funcs: string[]) {
        funcs.forEach((item) => {
            this.middlewareManager.use(item, middleware);
        });
    }




    protected errorMessageCatcher(e: any): IErrorResult {
        if (e?.isAxiosError && e?.status === 400)
            return {
                message: this.errorMessageHandle.HandelMessages(e.error),
                statusCode: e.status
            }
        else {
            return e;
        }
    }


    private _HandleUnauthorized(data: any): any {
        console.log('unauthorized error handler called');
    }

    private _HandleForbidden(data: any): any {
        console.log('forbidden error handler called');
    }

    private _HandleNotFound(data: any): any {
        console.log('notFound error handler called');
    }

    private _HandleBadRequest(data: any): any {
        console.log('BadRequest error handler called');
    }

    private _HandleInternalServerError(data: any): any {
        console.log('internalServerError error handler called');
    }

    private _HandleOther(code: number | undefined, data: any): any {
        console.log('error handler called ' + data);
    }
}
